import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { setSortByTime } from '../redux/lounges/slice';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import midBanner from '../assets/img/mid-banner-img.png';
import heroLogo from '../assets/img/mw-logo-2026.png';
import { Search } from '../components/Search';
import * as Sentry from '@sentry/react';
import '../css/responsive.css';
import {
  DARK_MODE_CHANGE_EVENT,
  isLoungeDarkModeEnabled,
  setLoungeDarkModeEnabled,
} from '../utils/loungeTheme';
import { getDeployVersionLabel } from '../utils/deployVersion';

export const LoungeHeader = () => {
  const [stTime, SetStTime] = useState<any>(false);
  const srtvalue = localStorage.getItem('shortByTime');
  const getpagename = localStorage.getItem('pagename');
  const dispatch = useAppDispatch();
  const location = useLocation();
  // Fetch the deployed version stamp so we can see which build a user is on
  // without DevTools.
  const [bootVersionLabel, setBootVersionLabel] = useState<string | null>(null);
  const [darkEnabled, setDarkEnabled] = useState(false);
  useEffect(() => {
    fetch('/version.txt', { cache: 'no-store' })
      .then((r) => (r.ok ? r.text() : null))
      .then((t) => {
        if (!t) return;
        try {
          const j = JSON.parse(t);
          setBootVersionLabel(getDeployVersionLabel(j));
        } catch {
          /* ignore */
        }
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    setDarkEnabled(isLoungeDarkModeEnabled());

    const handleDarkModeChange = (event: Event) => {
      const nextEnabled =
        event instanceof CustomEvent
          ? Boolean(event.detail?.enabled)
          : isLoungeDarkModeEnabled();
      setDarkEnabled(nextEnabled);
    };

    window.addEventListener(DARK_MODE_CHANGE_EVENT, handleDarkModeChange);
    return () => {
      window.removeEventListener(DARK_MODE_CHANGE_EVENT, handleDarkModeChange);
    };
  }, []);
  useEffect(() => {
    srtvalue == null ? SetStTime(false) : SetStTime(srtvalue);
  }, [srtvalue]);
  const onSoryTime = (sorTBY: any) => {
    SetStTime(sorTBY);
    localStorage.setItem('shortByTime', sorTBY);
    let SortTimeType: any = sorTBY;
    let sortingTime: any = null;

    dispatch(setSortByTime({ SortTimeType }));
  };
  const navigate = useNavigate()

  const isMobileViewport = () =>
    typeof window !== 'undefined' &&
    window.matchMedia('(max-width: 767.98px)').matches;
  
  const pageReload = () => {
    // On mobile the top-right menu sits over the banner; avoid accidental refresh taps.
    if (isMobileViewport()) return;
    window.scrollTo(0, 0);
    window.location.reload();
  }

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isMobileViewport()) {
      return;
    }
    pageReload();
  };

  let pathArray = window.location.pathname.split( '/' );

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  const handleClub333Click = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    const isInApp = localStorage.getItem('access') === 'app';
    
    if (isInApp) {
      if (!isAuthenticated) {
        window.alert("Please login from the Me tab in the MouseWait App first");
        return;
      }
    }

    if (!isAuthenticated) {
      navigate('/disneyland/login', { 
        state: { 
          returnTo: '/club333',
          source: localStorage.getItem('access')
        } 
      });
      return;
    }

    window.location.href = '/club333';
  };

  return (
    <>
      <div className='banner-img'>
        {
          (pathArray[1] == 'disneyworld') ?
          <>
            <img src={midBanner} className='img-fluid hellobhai' alt='mid-banner-img' />
            <Link to='/disneyworld/lounge' className="banner-logo"></Link>
          </>
          :
          <>
            <img
              src={midBanner}
              className='img-fluid'
              alt='mid-banner-img'
              onClick={() => pageReload()}
              style={{ cursor: isMobileViewport() ? 'default' : 'pointer' }}
            />
            <Link to='/disneyland/lounge/' className="banner-logo" onClick={handleLogoClick}></Link>
            {/* Modern hero — only visible under `.mw-lounge-modern` scope */}
            <Link
              to='/disneyland/lounge/'
              className='mw-hero'
              onClick={handleLogoClick}
              aria-label='Disneyland Lounge home'
            >
              <span className='mw-hero-glow' aria-hidden='true' />
              {/* Subtle fireworks bursts — same family as the Home
                  page hero effects. Six bursts at offset positions /
                  delays so they fire continuously but at different
                  times. CSS handles all animation. */}
              <span className='mw-hero-fireworks' aria-hidden='true'>
                <span className='mw-hero-burst' style={{ ['--x' as any]: '14%', ['--y' as any]: '34%', ['--delay' as any]: '0.2s', ['--dur' as any]: '6.4s' } as React.CSSProperties} />
                <span className='mw-hero-burst' style={{ ['--x' as any]: '72%', ['--y' as any]: '24%', ['--delay' as any]: '1.8s', ['--dur' as any]: '6.2s' } as React.CSSProperties} />
                <span className='mw-hero-burst' style={{ ['--x' as any]: '88%', ['--y' as any]: '62%', ['--delay' as any]: '3.4s', ['--dur' as any]: '6.8s' } as React.CSSProperties} />
                <span className='mw-hero-burst' style={{ ['--x' as any]: '44%', ['--y' as any]: '20%', ['--delay' as any]: '2.6s', ['--dur' as any]: '7.0s' } as React.CSSProperties} />
                <span className='mw-hero-burst' style={{ ['--x' as any]: '60%', ['--y' as any]: '70%', ['--delay' as any]: '4.2s', ['--dur' as any]: '6.0s' } as React.CSSProperties} />
                <span className='mw-hero-burst' style={{ ['--x' as any]: '28%', ['--y' as any]: '74%', ['--delay' as any]: '5.0s', ['--dur' as any]: '7.0s' } as React.CSSProperties} />
              </span>
              <span className='mw-hero-inner'>
                <img className='mw-hero-logo' src={heroLogo} alt='' aria-hidden='true' />
                <span className='mw-hero-text'>
                  <span className='mw-hero-title'>The Lounge</span>
                  <span className='mw-hero-tagline'>Connecting Disney Fans</span>
                </span>
              </span>
            </Link>
          </>
        }
      </div>
      <div className='top-trend'>
        <div className='text-head-trend text-center'>
          <div className='trending-actions'>
            <a
              className='trending-action-btn'
              href='/club333'
              onClick={handleClub333Click}
              target='_self'
              rel='noopener noreferrer'
            >
              Club 333
            </a>
            <a
              className='trending-action-btn'
              href='/disneyland/user/18/mypost'
              target='_self'
              rel='noopener noreferrer'
            >
              Admin Updates
            </a>
            <a
              className='trending-action-btn'
              href='/disneyland/tag/food/'
              target='_self'
              rel='noopener noreferrer'
            >
              Food Blog
            </a>
            <button
              type='button'
              className='trending-action-btn trending-action-btn--feed'
              onClick={() => onSoryTime(stTime === 'true' ? 'false' : 'true')}
            >
              {stTime === 'true'
                ? 'Feed: Post Time'
                : 'Feed: Default (Bumped)'}
            </button>
            {bootVersionLabel && (
              <span
                className='trending-action-btn trending-action-btn--version'
                aria-label={`MouseWait build version ${bootVersionLabel}`}
              >
                v{bootVersionLabel}
              </span>
            )}
            <button
              type='button'
              className={`trending-action-btn trending-action-btn--dark${
                darkEnabled ? ' trending-action-btn--dark-on' : ''
              }`}
              onClick={() =>
                setDarkEnabled(setLoungeDarkModeEnabled(!darkEnabled))
              }
              aria-label={
                darkEnabled
                  ? 'Switch the modern lounge to light mode'
                  : 'Switch the modern lounge to dark mode'
              }
            >
              {darkEnabled ? '☀ Light' : '☾ Dark'}
            </button>
          </div>

          <h6 className='trending-section-new'>
            {/*   {getpagename} (the name of the Land) */}
            {getpagename != '' ? <> {getpagename}</> : <> Disneyland Lounge</>}
          </h6>
          <Search />
        </div>
      </div>

    </>
  );
};
